/// <reference path="classes/basket.ts" />

$(document).ready(function()
{
    var bi = $('.basket-items-wrapper');

    bi.on('click', '.basket-item .basket-item-add', function() {
        var el = $(this).parents('.product');

        var basket:Basket = Basket.instance();

        basket.addItem(
            parseInt(el.find('.product-id').val()),
            el.find('.product-class').val(),
            parseFloat(el.find('.product-price').val()),
            {}
        );
    });

    bi.on('change', '.basket-item .basket-item-amount', function() {
        let el = $(this).parents('.basket-item');

        let basket:Basket = Basket.instance();


        let productId = parseInt(el.find('.product-id').val());
        let productClass = el.find('.product-class').val();
        let productClassSearch = productClass.replace('\\', '\\\\');
        let amount = 0;

        el.parents('.basket')
            .find('.product-id[value=' + productId + ']').parent('.basket-item')
            .find('.product-class[value=' + productClassSearch + ']')
            .each(function(){
                amount += parseFloat($(this).parents('.basket-item').find('.basket-item-amount').val());
            });

        basket.changeItem(productId, productClass, amount);
    });

    bi.on('click', '.basket-item .basket-item-remove', function() {
        var el = $(this).parents('.basket-item');

        var basket:Basket = Basket.instance();

        basket.removeItem(
            parseInt(el.find('.product-id').val()),
            el.find('.product-class').val()
        );
    });
});
